<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>
  <div class="mt-3"></div>
  <app-address-component [entity]="params.entity" [prefix]="params.addressPrefix"
    [isReadonly]="!params.editable"></app-address-component>
</ng-template>

<ng-template #footerTemplate>
  <div class="flex flex-row gap-2">
    <button pButton type="button" class="p-button-raised" [disabled]="!canSave()" (click)="saveChanges()">Save
    </button>
    <button pButton type="button" class="p-button-raised" (click)="cancelChanges()">Cancel
    </button>
  </div>
</ng-template>